import { AirtableRecord } from '@/modules/core/data/types/AirtableRecord';
import { Campus } from '@/modules/core/data/types/Campus';
import ChatbotQuestion from '@/modules/core/data/types/CDE/ChatbotQuestion';
import { ChatbotContext } from '@/modules/core/data/types/ChatbotContext';
import { EducationalProgram } from '@/modules/core/data/types/EducationalProgram';
import { EducationalProgramStep } from '@/modules/core/data/types/EducationalProgramStep';
import { ModChatbot } from '@/modules/core/data/types/ModChatbot';
import { StudentSolutionsCategory } from '@/modules/core/data/types/StudentSolutionsCategory';
import size from 'lodash.size';
import { ChatbotQuestions } from './getQuestionsToAsk';

/**
 * Find the next question to ask based on the question that's been answered
 *
 * Ignore questions that don't have any choices (no possible answer)
 */
export const findStartingQuestion = (context: ChatbotContext, questions: ChatbotQuestions, allEducationalPrograms: EducationalProgram[], allEducationalProgramSteps: EducationalProgramStep[], allCampuses: Campus[], allStudentSolutionsCategories: StudentSolutionsCategory[], modChatbot: AirtableRecord<ModChatbot>): ChatbotQuestion => {
  const {
    personaQuestion,
    programsQuestion,
    programStepsQuestion,
    campusesQuestion,
    categoryQuestion,
  } = questions;
  const isCategoryQuestionEnabled = modChatbot?.isCategoryQuestionEnabled;

  // If we start with known persona
  if (context.persona) {
    // Then start at the program question (if there are any program)
    if (size(allEducationalProgramSteps)) {
      return programsQuestion;
    } else {
      // Or start at the campus question (if there are any campus)
      if (size(allCampuses)) {
        return campusesQuestion;
      }

      // Or start at the category question (if there are any category and if the question is enabled)
      if (isCategoryQuestionEnabled && size(allStudentSolutionsCategories)) {
        return categoryQuestion;
      }
    }
  }

  return personaQuestion;
};

export default findStartingQuestion;
